




import { Component, Vue } from "vue-property-decorator";
import Action from "@/models/action";
import ProjectTemplate from "@/models/project-template";
import PlanList from "@/templates/PlanList.vue";
import { templateApi } from "@/api";

@Component({
  components: {
    PlanList
  }
})
export default class PlanListPage extends Vue {
  templates: ProjectTemplate[] = [];

  get actions(): Action[] {
    return [
      {
        key: "new",
        icon: "",
        text: "新規作成",
        variant: "default",
        click: () => {
          this.createTemplate("新しい工程プラン");
        }
      }
    ];
  }

  async duplicate(id: number) {
    const t = this.templates.find(t => t.id === id);
    if (!t) {
      throw new Error("template is not found.");
    }
    const newId = await this.duplicateTemplate(t);
    this.edit(newId);
  }

  // TODO 結構重いので、API側でduplicateしてもらったほうがいいかも

  async duplicateTemplate(t: ProjectTemplate) {
    return await templateApi.duplicate(t.id);
  }

  private created() {
    this.initTemplates();
  }

  private async initTemplates() {
    this.templates = await templateApi.getAll();
  }

  private async createTemplate(title: string) {
    const template = {
      title,
      id: 0,
      taskGroups: []
    };
    const id = await templateApi.save(template);
    this.edit(id);
  }

  private edit(id: number) {
    this.$router.push({ name: "plan-edit", params: { id: String(id) } });
  }
}
